export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5047.906de775.jpg";